import { useAtomValue } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { resolveDisplayTimezone } from "@/shared/timezone";

/**
 * Fuseau d'AFFICHAGE du cockpit — celui dans lequel l'horloge (bas-droite) et
 * toutes les heures « vues par cet utilisateur » sont rendues (shifts, rappels
 * de pointage, aperçus de programmation).
 *
 * Valeur persistée : `null` = AUTO (on suit le fuseau de l'appareil, détecté
 * via `Intl`), une chaîne IANA = override manuel posé en cliquant sur
 * l'horloge. Personnel à chaque poste (localStorage), donc un chatteur à +3h
 * voit ses vraies heures locales sans aucune config.
 *
 * `getOnInit: true` → lecture synchrone du localStorage dès l'init (pas de
 * bascule au mount).
 */
export const DISPLAY_TIMEZONE_STORAGE_KEY = "cockpit:display-timezone";

export const displayTimezoneAtom = atomWithStorage<string | null>(
  DISPLAY_TIMEZONE_STORAGE_KEY,
  null,
  undefined,
  { getOnInit: true },
);

/** Fuseau IANA EFFECTIF (override valide sinon appareil). À utiliser partout où
 *  on formate/convertit une heure « pour ce viewer ». */
export function useDisplayTimezone(): string {
  const override = useAtomValue(displayTimezoneAtom);
  return resolveDisplayTimezone(override);
}
